var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-config section verify-contracts"},[_c('h1',[_vm._v("Settings")]),_c('form',{staticClass:"flex"},[_c('form-row',_vm._b({},'form-row',_vm.formFields.FORMAT,false),[_c('export-format')],1),_c('form-row',_vm._b({},'form-row',_vm.formFields.DECIMALS,false),[_c('decimal-places')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }